// Shared rounding rules. Mirrored in auction-service + auction-integration so
// e-proc and SAP totals stay byte-identical (GR/SA decimal qty must match Payment Request).
// Spec: every qty*price line rounds HALF_UP like e-proc (IDR to whole rupiah, other currencies to 2 dp),
// and a total is the sum of those rounded lines.

export const isIDR = (currency) =>
  typeof currency === "string" && currency.toUpperCase() === "IDR"

const shiftDecimal = (value, places) => {
  const [mantissa, exponent] = value.toExponential().split("e")
  return +`${mantissa}e${+exponent + places}`
}

// Matches e-proc's BigDecimal HALF_UP; Math.round/toFixed on the raw float round 1.251 * 94325500
// (118001200.4999…) and 3.875 * 8000.44 (31001.704999…) down.
export const roundHalfUp = (value, scale) => {
  const decimal = +(Number(value) || 0).toPrecision(15)
  return Math.sign(decimal) * shiftDecimal(Math.round(shiftDecimal(Math.abs(decimal), scale)), -scale)
}

export const roundForCurrency = (value, currency) => roundHalfUp(value, isIDR(currency) ? 0 : 2)

export const roundIDR = (value) => roundHalfUp(value, 0)

export const multiplyIDR = (price, qty) => roundIDR((Number(price) || 0) * (Number(qty) || 0))

export const safeMultiply = (price, qty, currency) =>
  roundForCurrency((Number(price) || 0) * (Number(qty) || 0), currency)

// e-proc totals the rounded line subtotals, never the unrounded products (PM 500).
export const sumLineTotals = (lines, currency) =>
  roundForCurrency(lines.reduce((sum, [price, qty]) => sum + safeMultiply(price, qty, currency), 0), currency)
